import styled from 'vue-styled-components';

import { GRAY } from '@/styles/common.styled';
import {
    FLEX_COLUMN_DIV,
    FLEX_VERTICAL_CENTER_DIV,
    FLEX_CENTER_DIV,
} from '@/styles/common.styled.component';

export const ComponentWrapper = styled.div``;

export const TitleWrapper = styled.div`
    display: flex;
    align-items: center;

    h1 {
        font-size: 18px;
        font-weight: 500;
    }
`;

export const Tag = styled.div`
    border-radius: 12px;
    margin-left: 8px;
    font-size: 13px;
    padding: 3px 12px;
    border: 1px solid ${GRAY(30)};
    color: ${GRAY(80)};
`;

export const OptionsWrapper = styled(FLEX_COLUMN_DIV)`
    & > div:not(:last-child) {
        margin-bottom: 15px;
    }
`;

export const MainTitle = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
`;

export const LeftWrapper = styled(FLEX_COLUMN_DIV)`
    font-size: 18px;
    font-weight: 500;
    color: ${GRAY(100)};
`;

export const MainTitleTop = styled(FLEX_VERTICAL_CENTER_DIV)`
    color: ${GRAY(100)};
`;

export const HeaderLoaderWrapper = styled(FLEX_VERTICAL_CENTER_DIV)`
    position: relative;
    top: 6px;
    right: 12px;
    align-self: flex-start;
    color: ${GRAY(50)};
    font-weight: 500;
    font-size: 13px;
    & span {
        margin-left: 13px;
    }
`;

export const LoaderWrapper = styled(FLEX_CENTER_DIV)`
    margin-top: 30px;
`;

export const BlendDataBtn = styled.button`
    padding: 12px 27px;
    font-weight: 500;
    border-radius: 2px;
    border: 1px solid ${GRAY(30)};
    margin-top: 12px;
    align-self: flex-start;
`;

export const AbTeestingDescription = styled.span`
    display: block;
    text-align: right;
    color: ${GRAY(50)};
    font-size: 13px;
    font-weight: 400;
    margin-top: 4px;
    white-space: pre-line;
`;
